import { createI18n } from 'next-international';

import { TranslationsWithParameters } from './types';

const locales = {
	en: () => import('./en'),
	fr: () => import('./fr'),
	de: () => import('./de'),
	es: () => import('./es'),
	it: () => import('./it'),
	pt: () => import('./pt'),
} as const;

export const {
	useI18n,
	useScopedI18n,
	I18nProvider,
	useChangeLocale,
	defineLocale,
	getLocaleProps,
	useCurrentLocale,
} = createI18n<
	typeof locales,
	{
		en: TranslationsWithParameters;
		fr: TranslationsWithParameters;
		de: TranslationsWithParameters;
		es: TranslationsWithParameters;
		it: TranslationsWithParameters;
		pt: TranslationsWithParameters;
	}
>(locales);
